module.exports = new __parcel__URL__("loading_screen_prog_3.5805c950.png").toString();